<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
               {{year}} © LMS Leads.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    All rights reserved.
                </div>
            </div>
        </div>
    </div>
</footer>